// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@vanmeter/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { vmiLocationsErrorsModalStyles } from "@vanmeter/Overrides/Components/VmiLocationsErrorsModal";
import { fontConfig } from "@vanmeter/XDL/constants";
import { createLinkIconStyles, modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

vmiLocationsErrorsModalStyles.modal = {
    sizeVariant: "medium",
    cssOverrides: {
        modalTitle: css`
            justify-content: flex-start;
        `,
    },
};

vmiLocationsErrorsModalStyles.warningIcon = {
    src: "AlertTriangle",
    color: "danger.main",
    css: css`
        margin-right: 0;
        flex-shrink: 0;
    `,
};

vmiLocationsErrorsModalStyles.headerText = {
    variant: "h4",
};

vmiLocationsErrorsModalStyles.dataTable = {
    ...dataTableStyles.dataTable,
    cssOverrides: {
        table: css`
            margin-top: 15px;
        `,
    },
};

vmiLocationsErrorsModalStyles.instructionText = {
    ...fontConfig.smallSingleLine,
    css: css`
        margin-bottom: 12px;
    `,
};

vmiLocationsErrorsModalStyles.templateLink = {
    ...createLinkIconStyles({
        icon: "Download",
        sizeVariant: "small",
        linkStyles: {
            css: css`
                margin-top: 12px;
                display: block;
            `,
        },
    }),
};

vmiLocationsErrorsModalStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

vmiLocationsErrorsModalStyles.cancelUploadButton = {
    ...modalButtonsActionStyles.cancelButton,
};

vmiLocationsErrorsModalStyles.continueUploadButton = {
    ...modalButtonsActionStyles.submitButton,
};
